import glamorous from 'glamorous';
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import IconButton from '../../../components/IconButton';
import { competences } from '../../../data';
import toCamelCase from '../../../utils/toCamelCase';

const IconWithTitle = glamorous.div(({ gridArea }) => ({
  display: 'grid',
  gridAutoFlow: 'row',
  justifyItems: 'center',
  gridArea,
  textAlign: 'center',
  gridGap: '5px',
  '&:hover p': {
    color: '#B68962',
  },
}));

const Wrapper = glamorous.div({
  display: 'grid',
  padding: '2em 0',
  width: '75%',
  margin: 'auto',
});

const Grid = glamorous.div({
  '@media only screen and (min-width: 480px)': {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, 1fr)',
    gridTemplateRows: 'repeat(2,1fr)',
    gridTemplateAreas: `
    "fonctionPublique . urbanismeEtConstruction . marchePublic"
    ". contentieuxDesAidesSociales . responsabiliteMedicale ."
  `,
  },
});

const Title = glamorous.p({
  color: 'black',
});
const renderButtonIcon = (key, icon, title) => (
  <IconWithTitle gridArea={key}>
    <Link
      to={`/competences/${toCamelCase(title)}`}
      href={`/competences/${toCamelCase(key)}`}
    >
      <IconButton icon={icon} />
      <Title>{title}</Title>
    </Link>
  </IconWithTitle>
);

export default class Competences extends PureComponent {
  render() {
    return (
      <Wrapper>
        <h1>Compétences</h1>
        <Grid>
          {competences.map(({ name, icon, title }) =>
            renderButtonIcon(name, icon, title),
          )}
        </Grid>
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/home/components/Competences.jsx